import {Component, OnDestroy, OnInit} from '@angular/core';
import SewingPatternProject from '../../../models/sewing-pattern-project.model';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfiguratorService} from '../../../services/configurator/configurator.service';
import {PatternShareService} from '../../../services/pattern/pattern-share.service';
import {PatternRepository} from '../../../repositories/pattern.repository';
import SewingPatternInterface from '../../../models/sewing-pattern.interface';

@Component({
  selector: 'app-pattern-details',
  templateUrl: './pattern-details.page.html',
  styleUrls: ['./pattern-details.page.css'],
})
export class PatternDetailsPage implements OnInit, OnDestroy {

  sewingPattern: SewingPatternInterface;

  private patternId$;

  constructor(private route: ActivatedRoute, private patternRepository: PatternRepository, private router: Router) { }

  ngOnDestroy(): void {
    this.patternId$?.unsubscribe();
  }

  ngOnInit(): void {
    this.patternId$ = this.route.params.subscribe(params => {
      this.sewingPattern = this.patternRepository.getByIdOrFirst(params.patternId);
    });
  }

  navigateToConfigurator() {
    this.router.navigate(['configurator/' + this.sewingPattern.id ]);
  }
}
